module.exports = __webpack_public_path__ + "images/花筑pr长图_04-3.jpg?v=066f9bb2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu1/花筑pr长图_04-3.jpg
 ** module id = 16
 ** module chunks = 1 2
 **/